// a11y: a text list of the nearest dealers, so the locator works without the map
// (WCAG 1.1.1, 2.1.1, 4.1.3). Uses geoStores, geocoder, haversineMiles and lastSearched
// from map.js, which loads first.
(function () {
  var LIST_SIZE = 10;
  var statusEl = document.getElementById("dealerListStatus");
  var listEl = document.getElementById("dealerList");
  if (!statusEl || !listEl || typeof geocoder === "undefined") return;

  var lastCenter = null;
  var shown = [];

  // Nick, 2026-10-20: a card works like its map pin. It scrolls to the map, centres on the
  // dealer and opens the same pop-up; Mapbox moves focus into the pop-up when it opens.
  function showOnMap(index) {
    var item = shown[index];
    if (!item) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var mapEl = document.getElementById("map");
    if (mapEl) mapEl.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    map.easeTo({ center: item.coords, zoom: 10, duration: reduce ? 0 : 800 });
    popup.setLngLat(item.coords).setHTML(buildPopup(item.store)).addTo(map);
  }

  listEl.addEventListener("click", function (e) {
    if (e.target.closest("a")) return;
    var card = e.target.closest(".dealer-list__item");
    if (card) showOnMap(Number(card.dataset.index));
  });
  var lastPlace = "";

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function matchesFilters(store) {
    var checked = function (id) {
      var el = document.getElementById(id);
      return el && el.checked;
    };
    if (checked("ls3") && !(store.ls3Stock > 0)) return false;
    if (checked("ls4") && !(store.ls4Stock > 0)) return false;
    if (checked("hh4") && !(store.hh4Stock > 0)) return false;
    if (checked("finance") && store.financing !== true) return false;
    return true;
  }

  function websiteUrl(site) {
    if (!site) return "";
    return /^https?:\/\//i.test(site) ? site : "http://" + site;
  }

  function render() {
    if (!lastCenter) return;
    if (!geoStores.length) {
      statusEl.textContent = "Dealer list is still loading. Please search again in a moment.";
      return;
    }
    var lng = lastCenter[0];
    var lat = lastCenter[1];
    var nearest = geoStores
      .filter(function (f) { return matchesFilters(f.properties); })
      .map(function (f) {
        var c = f.geometry.coordinates;
        return { store: f.properties, coords: c, miles: haversineMiles(lat, lng, c[1], c[0]) };
      })
      .sort(function (a, b) { return a.miles - b.miles; })
      .slice(0, LIST_SIZE);

    shown = nearest;
    listEl.innerHTML = nearest.map(function (item, index) {
      var s = item.store;
      var address = [s.street, [s.city, s.state].filter(Boolean).join(", "), s.zip].filter(Boolean).join(", ");
      var directions = "https://www.google.com/maps/dir/" + encodeURIComponent(lastPlace) + "/" + encodeURIComponent(address) + "/";
      var stock = "Stock: LS3 " + (s.ls3Stock || 0) + ", LS4 " + (s.ls4Stock || 0) + ", HH4 " + (s.hh4Stock || 0);
      var site = websiteUrl(s.website);
      return (
        '<li class="dealer-list__item" data-index="' + index + '">' +
          '<h3 class="dealer-list__name"><button type="button" class="dealer-list__show" data-index="' + index + '">' +
            escapeHtml(s.title) + '<span class="visually-hidden">, show on the map</span></button>' +
            (s.newDealer ? ' <span class="dealer-list__new">New dealer</span>' : "") + "</h3>" +
          "<p>" + escapeHtml(address) + " (" + item.miles.toFixed(1) + " miles)</p>" +
          (s.phone ? '<p><a href="tel:' + escapeHtml(String(s.phone).replace(/[^0-9+]/g, "")) + '">' + escapeHtml(s.phone) + "</a></p>" : "") +
          "<p>" + stock + (s.financing ? ". Financing available" : "") + "</p>" +
          '<p class="dealer-list__links">' +
            '<a href="' + escapeHtml(directions) + '" target="_blank" rel="noopener">Directions<span class="visually-hidden"> to ' + escapeHtml(s.title) + " (opens in a new tab)</span></a>" +
            (site ? ' <a href="' + escapeHtml(site) + '" target="_blank" rel="noopener">Website<span class="visually-hidden"> of ' + escapeHtml(s.title) + " (opens in a new tab)</span></a>" : "") +
          "</p>" +
        "</li>"
      );
    }).join("");

    var names = { ls3: "LS3 in stock", ls4: "LS4 in stock", hh4: "HH4 in stock", finance: "financing" };
    var active = Object.keys(names).filter(function (id) {
      var el = document.getElementById(id);
      return el && el.checked;
    }).map(function (id) { return names[id]; });
    var withText = active.length ? " with " + active.join(" and ") : "";
    statusEl.textContent = nearest.length
      ? nearest.length + " dealer" + (nearest.length > 1 ? "s" : "") + withText + " nearest to " + lastPlace + ", listed below the map."
      : "No dealers" + withText + " found. Try clearing a filter.";
  }

  geocoder.on("result", function (result) {
    lastCenter = result.result.center;
    lastPlace = result.result.place_name || "your search";
    render();
  });

  ["ls3", "ls4", "hh4", "finance"].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener("change", render);
  });
})();
